import { useSelector } from 'react-redux';
import { selectPages } from '@mm/state/selectors/pageSelectors';
import { useCallback } from 'react';
import { InputTrigger } from './InputTriggers/use-input-triggers-identification';
import { IDiagramElements } from './DialogueEditor/DialogueEditor';
import { getAutomationReviewRequiredCount } from '@mm/state/selectors/automations';

export const useNeedsReview = () => {
  const pages = useSelector(selectPages);
  const count = useSelector(getAutomationReviewRequiredCount);

  const getPage = (id?: number) => {
    return pages.find(page => page.id.toString() === id?.toString());
  };

  const pageNeedsReview = useCallback(
    (pageId?: number) => {
      const page = getPage(pageId);
      return !!page?.needsReview;
    },
    [pages],
  );

  const deriveCount = useCallback(
    ({
      triggers,
      elements,
    }: {
      triggers?: InputTrigger[] | null;
      elements?: IDiagramElements | null;
    }) => {
      return (
        (triggers?.filter(p => pageNeedsReview(p.pageId)).length || 0) +
        (elements?.filter(w => w?.data?.widget?.needsReview).length || 0)
      );
    },
    [pageNeedsReview],
  );

  return { count, deriveCount, pageNeedsReview };
};
